import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IncludeExcludeFiltersModel } from '../../../dto';

@Component({
    selector: 'app-owned-contacts-applied-text',
    template: `
    <ng-container *ngIf="value?.owned_contacts_company?.exclude?.length || value?.owned_contacts_person?.exclude?.length">
      This search includes an owner-based <span class="italic">exclude</span> filter; actual results count may be lower.
    </ng-container>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class OwnedContactsAppliedFilterTextComponent {
  @Input() value: Partial<{ owned_contacts_company: IncludeExcludeFiltersModel, owned_contacts_person: IncludeExcludeFiltersModel }>;
}
